import * as React from 'react'
import Svg, { Path } from 'react-native-svg'
import { Props } from './type'
export const MinusIcon = (props: Props) => (
  <Svg viewBox='0 0 20 20' fill='none' {...props}>
    <Path
      d='M4.16675 10H15.8334'
      stroke='#425563'
      strokeWidth={2}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </Svg>
)
